module.exports = __webpack_public_path__ + "static/media/heart.fcdcabd6.svg";